import { useState } from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function LoginModal({ 
  show, 
  onSubmit, 
  error, 
  loading,
  title = "Enter Password"
}) {
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.trim()) {
      onSubmit(password);
      window.history.replaceState(null, '', `${window.location.pathname}?admin=true`);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  if (!show) return null;

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <div className="modal-header">
          <Link to="/" className="home-link">
            <Home className="home-icon" size={32} />
          </Link>
          <h2>{title}</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            disabled={loading}
            autoFocus
          />
          {error && <p className="error">{error}</p>}
          <button 
            type="submit" 
            disabled={loading || !password.trim()}
          >
            {loading ? "Authenticating..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
